<template>
    <page-header-wrapper>
        <a-card :bordered="false">
            <!-- 条件搜索 -->
            <!-- <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="奖品名称" prop="prizeName">
                                <a-input v-model="queryParam.prizeName" placeholder="请输入奖品名称" allow-clear />
                            </a-form-item>
                        </a-col>


                        <a-col :md="8" :sm="24">
                            <a-form-item label="奖品英文名称" prop="prizeNameEn">
                                <a-input v-model="queryParam.prizeNameEn" placeholder="请输入奖品英文名称" allow-clear />
                            </a-form-item>
                        </a-col>

                        <template v-if="advanced">
                            <a-col :md="8" :sm="24">
                                <a-form-item label="奖品概率" prop="probability">
                                    <a-input v-model="queryParam.probability" placeholder="请输入奖品概率" allow-clear />
                                </a-form-item>
                            </a-col>

                            <a-col :md="8" :sm="24">
                                <a-form-item label="地址" prop="address">
                                    <a-input v-model="queryParam.address" placeholder="请输入地址" allow-clear />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :md="!advanced && 8 || 24" :sm="24">
                            <span class="table-page-search-submitButtons"
                                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div> -->
            <!-- 操作 -->
            <div class="table-operations">
                <a-button type="primary" @click="$refs.createForm.handleAdd()">
                    <a-icon type="plus" />新增
                </a-button>
                <a-button type="danger" :disabled="multiple" @click="handleDelete">
                    <a-icon type="delete" />删除
                </a-button>
                <a-butt />
                <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
                    :refresh-loading="loading" @refresh="getList" />
            </div>
            <!-- 增加修改 -->
            <create-form ref="createForm" @ok="getList" />
            <!-- 数据展示 -->
            <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
                :bordered="tableBordered">
                <span slot="createTime" slot-scope="text, record">
                    {{ parseTime(record.createTime) }}
                </span>

                <span slot="operation" slot-scope="text, record">
                    <a-divider type="vertical" />
                    <a v-if="record.status == 0  && user.userId == 1" @click="handleConfirm(record)">
                        <a-icon type="edit" />审核
                    </a>
                    <a-divider type="vertical" />
                    <a @click="$refs.createForm.handleUpdate(record, undefined)">
                        <a-icon type="edit" />修改
                    </a>
                    <a-divider type="vertical" />
                    <a @click="handleDelete(record)">
                        <a-icon type="delete" />删除
                    </a>
                </span>
            </a-table>
            <!-- 分页 -->
            <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange" @change="changeSize" />
        </a-card>
    </page-header-wrapper>
</template>
  
<script>
import { page, add, update, del, confirm } from '@/api/privilegeCampaign/privilegeCampaign'
import { getInfo } from '@/api/login'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'PrivilegeCampaign',
    components: {
        CreateForm
    },
    mixins: [tableMixin],
    data() {
        return {
            user: {},
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            total: 0,
            // 查询参数
            queryParam: {
                prizeName: null,
                prizeNameEn: null,
                prizeCover: null,
                probability: null,
                isBan: null,
                address: null,
                pageNum: 1,
                pageSize: 10
            },
            columns: [
                {
                    title: '活动ID',
                    dataIndex: 'id',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '文案',
                    dataIndex: 'rewardContent',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '奖励类型',
                    dataIndex: 'type',
                    ellipsis: true,
                    align: 'center',
                    customRender: function (t, r, index) {
                        if (t == 0) {
                            return '会员'
                        } else if (t == 1) {
                            return '金币'
                        }
                    }
                },
                {
                    title: '发放数量',
                    dataIndex: 'number',
                    ellipsis: true,
                    align: 'center',
                },
                {
                    title: '有效时间',
                    dataIndex: 'expiresTime',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    ellipsis: true,
                    align: 'center',
                },
                {
                    title: '审核状态',
                    dataIndex: 'status',
                    ellipsis: true,
                    align: 'center',
                    customRender: function (t, r, index) {
                        if (t == 0) {
                            return '待审核'
                        } else if (t == 1) {
                            return '已发放'
                        }
                    }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    ellipsis: true,
                    align: 'center',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '18%',
                    scopedSlots: { customRender: 'operation' },
                    align: 'center'
                }
            ]
        }
    },
    filters: {
    },
    created() {
        this.getList()
        this.getUser()
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getUser() {
            getInfo().then(response => {
                this.user = response.data
                console.log("=================用户信息", this.user)
                this.roleGroup = response.roleGroup
                this.postGroup = response.postGroup
            })
        },
        /** 查询抽奖奖品列表 */
        getList() {
            this.loading = true
            page(this.queryParam).then(response => {
                this.list = response.data.records
                this.total = response.data.total
                this.loading = false
            })
        },


        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
                prizeName: undefined,
                prizeCover: undefined,
                probability: undefined,
                isBan: undefined,
                address: undefined,
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map(item => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        handleConfirm(row) {
            const that = this
            const { id, userIds, type, number, expiresTime } = row
            this.$confirm({
                title: '是否确定通过审核?',
                content: '当前选中编号为' + id + '的数据',
                onOk() {
                    const data = { id, userIds, type, number, expiresTime }
                    return confirm(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '审核通过',
                                3
                            )
                        })
                        .catch(() => {
                            that.$message.error('审核失败')
                        })
                },
                onCancel() {
                    //取消清空删除ids列表
                }
            })
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            const ids = row.id || this.ids
            if (row.id) {
                this.ids.push(row.id)
            }
            this.$confirm({
                title: '确认删除所选中数据?',
                content: '当前选中编号为' + ids + '的数据',
                onOk() {
                    let data = []
                    that.ids.map(id => data.push({ "id": id }))
                    return del(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '删除成功',
                                3
                            )
                        })
                },
                onCancel() {
                    //取消清空删除ids列表
                    that.ids = []
                }
            })
        },
    }
}
</script>
  